var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 2H9.00012C4.00012 2 2.00012 4 2.00012 9V15C2.00012 20 4.00012 22 9.00012 22H15.0001C20.0001 22 22.0001 20 22.0001 15V13",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0401 3.02001L8.16012 10.9C7.86012 11.2 7.56012 11.79 7.50012 12.22L7.07012 15.23C6.91012 16.32 7.68012 17.08 8.77012 16.93L11.7801 16.5C12.2001 16.44 12.7901 16.14 13.1001 15.84L20.9801 7.96001C22.3401 6.60001 22.9801 5.02001 20.9801 3.02001C18.9801 1.02001 17.4001 1.66001 16.0401 3.02001Z",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9102 4.15002C15.5802 6.54002 17.4502 8.41002 19.8502 9.09002",
    stroke: "#494A4B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.62d528f38fb50c3ba8a9b8537f181dd7.svg";
export { ForwardRef as ReactComponent };